module.exports = __webpack_public_path__ + "static/media/branch.fa13d178.png";